// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3FmlD","errorLogs":"EditorFooter_errorLogs__EAhGD"};